export const Types = {
  GET_USER_REQUEST: '@user/GET_USER_REQUEST',
  GET_USER_SUCCESS: '@user/GET_USER_SUCCESS',
  GET_USER_FAILURE: '@user/GET_USER_FAILURE',
  EDIT_USER_REQUEST: '@user/EDIT_USER_REQUEST',
  EDIT_USER_SUCCESS: '@user/EDIT_USER_SUCCESS',
  EDIT_USER_FAILURE: '@user/EDIT_USER_FAILURE',
};

export const getUserRequest = payload => ({
  type: Types.GET_USER_REQUEST,
  payload,
});

export const getUserSuccess = payload => ({
  type: Types.GET_USER_SUCCESS,
  payload,
});

export const getUserFailure = () => ({
  type: Types.GET_USER_FAILURE,
});

export const editUserRequest = payload => ({
  type: Types.EDIT_USER_REQUEST,
  payload,
});

export const editUserSuccess = () => ({
  type: Types.EDIT_USER_SUCCESS,
});

export const editUserFailure = () => ({
  type: Types.EDIT_USER_FAILURE,
});
